// firebaseConfig.js
import { initializeApp } from 'firebase/app';
import { browserLocalPersistence, connectAuthEmulator, getAuth, setPersistence } from 'firebase/auth';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore/lite';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

const app = initializeApp(firebaseConfig);
export { app };
export const db = getFirestore(app);
export const auth = getAuth(app);
if (process.env.REACT_APP_USE_FIREBASE_EMULATORS === 'true') {
  const emulatorHost = process.env.REACT_APP_FIREBASE_EMULATOR_HOST || '127.0.0.1';
  connectFirestoreEmulator(db, emulatorHost, Number(process.env.REACT_APP_FIRESTORE_EMULATOR_PORT || 8080));
  connectAuthEmulator(
    auth,
    `http://${emulatorHost}:${Number(process.env.REACT_APP_AUTH_EMULATOR_PORT || 9099)}`,
    { disableWarnings: true },
  );
}
export const authReady = setPersistence(auth, browserLocalPersistence);
